import { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import { AuthContextValue } from '../types/AuthTypes';

/**
 * useAuth
 * 
 * Hook to access authentication context
 * 
 * @example
 * const { isAuthenticated, account, token, logout } = useAuth();
 */
export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};
